import { AVNStageProps } from 'application/api'
import { useGate, useStore } from 'effector-react'
import {
  $cars,
  $carsStageGate,
  $failed,
  $fetching,
  $pagesLoaded,
  $totalCount,
  CarsListProps,
  loadNextPage
} from 'features/cars-list/model'
import { CreditFilterForm } from 'features/credit-filter-form/components/index'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { useAVNConfig } from 'stages/AVN'
import styled, { useTheme } from 'styled-components'
import { Button } from 'ui/button'
import { CarCardsList } from 'ui/car-cards-list'
import { Cell, Row } from 'ui/grid'
import { SkeletonCard } from 'ui/skeleton-card'
import { StageError } from 'ui/stage-error'

import { logger } from '../../../lib/logger'
import { $creditFilterEnabled, setCreditAvailable } from '../../credit-filter-form/model'
import { carDataToSCCar, useListSmartContractAPI } from '../../smart-contract/list/useListSmartContractAPI'
import { CommercialFilters } from './CommercialFilters'
import { SelectedFilters } from './SelectedFilters'

export const CarsList: FC<{}> = () => {
  const props = useAVNConfig()
  const theme = useTheme()
  const [creditFilterFormOpen, setCreditFilterFormOpen] = useState(false)
  useGate($carsStageGate, { carsListProps: props, appTheme: theme })

  const cars = useStore($cars)
  const pagesLoaded = useStore($pagesLoaded)
  const totalCount = useStore($totalCount)
  const failed = useStore($failed)
  const fetching = useStore($fetching)
  const creditFilterEnabled = useStore($creditFilterEnabled)

  const { init, api, state } = useListSmartContractAPI()

  const skeletons = useMemo(() => {
    const pageSize = props.pageLength || 25
    const imageRatio = props.carViewSettings.images.ratio || { x: 16, y: 9 }
    return Array.from({ length: pageSize * pagesLoaded }, (_, i) => {
      return (
        <Cell size={12} phablet={6} projectors={4} key={i} gutters={true}>
          <SkeletonCard ratio={imageRatio} />
        </Cell>
      )
    })
  }, [])

  const showSkeletons = fetching && !cars

  useEffect(() => {
    if (!props.smartContractInstalled) {
      setCreditAvailable(false)
    }
    if (!failed && !fetching && cars && props.smartContractInstalled) {
      logger.log('[SC/updateCarList]', carDataToSCCar(cars))
      init(cars, props.isNew)
      api.updateCarList(carDataToSCCar(cars))
      console.log('--777---carDataToSCCar(cars)', carDataToSCCar(cars))
    }
  }, [fetching, cars, failed])

  return (
    <>
      <CreditFilterForm onClose={() => setCreditFilterFormOpen(false)} show={creditFilterFormOpen} />

      {failed ? (
        <Row>
          <Cell size={12} gutters={true}>
            <StageError text={props.i18n.loadingError} />
          </Cell>
        </Row>
      ) : (
        <>
          <CommercialFilters openCreditFilterForm={() => setCreditFilterFormOpen(true)} />
          <SelectedFilters />
          <CarCardsList
            showCreditPrice={true}
            openCardsLinksInNewTab={props.openCardsLinksInNewTab}
            carViewSettings={props.carViewSettings}
            useSmartContract={
              props.smartContractInstalled &&
              (creditFilterEnabled || Boolean(state && state.tradeIn.behaviourByUser === 'applied'))
            }
            cars={cars}
            emptyText={props.i18n.noCarsFound}
            showSkeletons={showSkeletons}
            skeletons={skeletons}
            showVideoIcon={props.showVideoIcon}
            cardSize={{
              size: 12,
              phablet: 6,
              projectors: 4
            }}
          />
          {props.pageLength && pagesLoaded * props.pageLength < totalCount && (
            <Row justifyContent={'center'} alignItems={'center'}>
              <Cell auto>
                <Button onClick={loadNextPage} disabled={fetching} size={'big'} icon={'arrow-down'}>
                  {props.i18n.loadMore}
                </Button>
              </Cell>
            </Row>
          )}
        </>
      )}
    </>
  )
}
